import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
  fonts: {
    body: `'Poppins', sans-serif`,
  },
});

export default theme;
